(function () {
    'use strict';
    angular
        .module('ib-checkin-services-module')
        .factory('UtilsService', UtilsService);

    UtilsService.$inject = ['$window', '$rootScope', 'CloseSessionService', 'CommonsSessionStorageService', '$q', 'IbCAuthTokenService', '$filter', 'CheckinAppConstants', '$location', 'CurrencyService', 'ModalService', 'CommonsUtilService', 'localStorageService', 'DatalayerUniqueKeysService','$timeout', 'CommonsUserUtilsService'];
    function UtilsService ($window, $rootScope, CloseSessionService, CommonsSessionStorageService, $q, IbCAuthTokenService, $filter, CheckinAppConstants, $location, CurrencyService, ModalService, CommonsUtilService, localStorageService, DatalayerUniqueKeysService, $timeout, CommonsUserUtilsService) {
        const estaConstraint = {
            showTextEsta: false,
            text: ''
        };

        return {
            getDeviceType: getDeviceType,
            getAuthToken: getAuthToken,
            Base64Decode: Base64Decode,
            getParameterByName: getParameterByName,
            getPathParameterByName: getPathParameterByName,
            getPassengersInfo: getPassengersInfo,
            filterAdditionalInfo: filterAdditionalInfo,
            setFareFamilyConditions: setFareFamilyConditions,
            generatePassengersQueryString: generatePassengersQueryString,
            generateBuildNumberQueryString: generateBuildNumberQueryString,
            checkPendingPayments: checkPendingPayments,
            checkFailedPendingPayments: checkFailedPendingPayments,
            getCachedSelectedInfo: getCachedSelectedInfo,
            getCabinClassName: getCabinClassName,
            isValidPassengerStatus: isValidPassengerStatus,
            getTripSegments: getTripSegments,
            getMarketLabel: getMarketLabel,
            getSSOErrorCodeMessage: getSSOErrorCodeMessage,
            isPassengerSelected: isPassengerSelected,
            validLuhnCompanyCard: validLuhnCompanyCard,
            updateSegmentCabinClass: updateSegmentCabinClass,
            initStorage: initStorage,
            checkConfirmationPNR: checkConfirmationPNR,
            saveEndpoints: saveEndpoints,
            getEndpoint: getEndpoint,
            getMetaTagValueByName: getMetaTagValueByName,
            getTravelAgencies: getTravelAgencies,
            getAirlineLogos: getAirlineLogos,
            updateSelectedSegments: updateSelectedSegments,
            updateCachedInfo: updateCachedInfo,
            isUserLogged: isUserLogged,
            cleanSpaces: cleanSpaces,
            getSlashDate: getSlashDate,
            getMiddleDashDate: getMiddleDashDate,
            generateUpdateSeatsMap: generateUpdateSeatsMap,
            getReInvoicing: getReInvoicing,
            updateCachedInformation: updateCachedInformation,
            getSegmentSeatsPending: getSegmentSeatsPending,
            updateSegmentSeatStatus: updateSegmentSeatStatus,
            checkEarlySegments: checkEarlySegments,
            checkEarlyFlights: checkEarlyFlights,
            goIbCose: goIbCose,
            checkCompany: checkCompany,
            getInfoHeader: getInfoHeader,
            getHeadeUpgradingInfo: getHeadeUpgradingInfo,
            getElementsByProperty: getElementsByProperty,
            generateHeaderTripsInfo: generateHeaderTripsInfo,
            getSegmentsInfo: getSegmentsInfo,
            getPaymentsBackGroundURL: getPaymentsBackGroundURL,
            setAncillariesCurrency: setAncillariesCurrency,
            warnUserOnBackPressed: warnUserOnBackPressed,
            removeParameterURL: removeParameterURL,
            setAncillariesBob: setAncillariesBob,
            backToMain: backToMain,
            setAircraftDatalayer: setAircraftDatalayer,
            getAppMarket: getAppMarket,
            getPrefixFromMarket: getPrefixFromMarket,
            updateLanguageAdditionalInfo: updateLanguageAdditionalInfo,
            getAppLang: getAppLang,
            setTitlePage: setTitlePage,
            showPriorityAlertInhibit: showPriorityAlertInhibit,
            checkInhibitReason: checkInhibitReason,
            priorityInhibit: priorityInhibit,
            filterMarket: filterMarket,
            concatUnique: concatUnique,
            updateApiEsta: updateApiEsta,
            checkApisEsta: checkApisEsta,
            cleanDataSoftUser: cleanDataSoftUser
        };

        function getDeviceType () {
            let width;
            let deviceType = '';
            const channel = CommonsSessionStorageService.get('channel');
            if (channel === 'mobi') {
                deviceType = 'mobile';
            } else {
                width = $window.innerWidth;
                if (width !== null) {
                    if (width >= 1024) {
                        deviceType = 'desktop';
                    } else if (width > 480 && width < 1025) {
                        deviceType = 'tablet';
                    } else if (width < 481) {
                        deviceType = 'mobile';
                    }
                }
            }
            return deviceType;
        }

        function getAuthToken () {
            return CommonsSessionStorageService.get('userLogged') ? CommonsSessionStorageService.get('loggedToken') : CommonsSessionStorageService.get('anonymousToken');
        }

        function refreshToken () {
            const defered = $q.defer();

            if (CommonsSessionStorageService.get('userLogged')) {
                IbCAuthTokenService.refreshUserLoggedToken().then(success, serviceError);
            } else {
                IbCAuthTokenService.getAnonymousToken().then(success, serviceError);
            }

            function success () {
                defered.resolve();
            }

            function serviceError (error) {
                ModalService.isNotWaiting();
                ModalService.setErrorMessage(error.message);
                ModalService.setErrorCode(error.internalErrorCode);
                ModalService.isError(error);
            }
            return defered.promise;
        }

        function Base64Decode (str, utf8decode) {
            const Base64 = {};
            let o1, o2, o3, h1, h2, h3, h4, bits, d = [], plain, coded, b64, c;
            Base64.code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            utf8decode = angular.isUndefined(typeof utf8decode) ? false : utf8decode;
            b64 = Base64.code;

            coded = utf8decode ? Utf8.decode(str) : str;

            for (c = 0; c < coded.length; c += 4) {
                h1 = b64.indexOf(coded.charAt(c));
                h2 = b64.indexOf(coded.charAt(c + 1));
                h3 = b64.indexOf(coded.charAt(c + 2));
                h4 = b64.indexOf(coded.charAt(c + 3));

                bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

                o1 = bits >>> 16 & 0xff;
                o2 = bits >>> 8 & 0xff;
                o3 = bits & 0xff;

                d[c / 4] = String.fromCharCode(o1, o2, o3);
                if (h4 === 0x40) d[c / 4] = String.fromCharCode(o1, o2);
                if (h3 === 0x40) d[c / 4] = String.fromCharCode(o1);
            }
            plain = d.join('');
            return utf8decode ? Utf8.decode(plain) : plain;
        }

        function getParameterByName (name, url) {
            let regex;
            let results;
            if (!url) url = $window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi');
            results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            const resultDecode = name !== 'code' ? results[2].replace(/\+/g, ' ') : results[2];
            return decodeURIComponent(resultDecode);
        }
        function getPathParameterByName (name) {
            let regex, results, url = $window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi');
            results = regex.exec(url);
            return results && results[2] ? results[2] : null;
        }

        function getTravelAgencies (name) {
            const travelAgencies = getParameterByName(name);
            return travelAgencies && travelAgencies.toLowerCase() === 'true';
        }

        /**
         * Return value of parameter recieved on URL
         * @param {String} parameter Parameter
         */
        function getReInvoicing (parameter) {
            const travelAgenciesReInvoincing = getParameterByName(parameter);
            return travelAgenciesReInvoincing && travelAgenciesReInvoincing.toLowerCase() === 'true';
        }

        function generatePassengersQueryString (passengersId) {
            const passengers = passengersId || [];
            let queryString = '';
            let i;
            for (i = 0; i < passengers.length; i++) {
                queryString += (queryString === '' ? '?' : '&') + 'passengerId=' + passengers[i];
            }
            return queryString;
        }

        function generateBuildNumberQueryString () {
            const buildNumber = getMetaTagValueByName('buildNumber');
            return buildNumber && buildNumber !== '' ? ('?buildNumber=' + buildNumber) : '';
        }

        function checkPendingPayments (bookingInfo) {
            let i = 0, found = false;
            while (!found && i < bookingInfo.passengers.length) {
                found = bookingInfo.passengers[i].pendingPayment;
                i++;
            }
            return found;
        }

        function checkFailedPendingPayments (cancelData) {
            let i, j, returnedFailedItems;
            if (cancelData !== null && cancelData.failedToDelete) {
                for (i = 0; i < cancelData.failedToDelete.length; i++) {
                    if (cancelData.failedToDelete[i].type === CheckinAppConstants.ANCILLARIES_TYPES.SEAT) {
                        for (j = 0; j < cancelData.failedToDelete[i].segments.length; j++) {
                            returnedFailedItems += cancelData.failedToDelete[i].segments[j].error.description;
                        }
                    } else if (cancelData.failedToDelete[i].type === CheckinAppConstants.ANCILLARIES_TYPES.BAGGAGE) {
                        for (j = 0; j < cancelData.failedToDelete[i].segments.length; j++) {
                            returnedFailedItems += cancelData.failedToDelete[i].pasengers[j].error.description;
                        }
                    } else if (cancelData.failedToDelete[i].type === CheckinAppConstants.ANCILLARIES_TYPES.UPGRADING) {
                        returnedFailedItems += cancelData.failedToDelete[i].error.description;
                    }
                }
            }
            return returnedFailedItems;
        }

        /**
        * Return the passengers Info.
        * @param {String} passengersInfo -passenger info
        * @returns {String} - the passengers info transformed
        */

        function getPassengersInfo (passengersInfo) {
            const additionalInfo = [], emergencyInfo = [], newsLettersInfo = [], passengerAvailable = [];
            let i, useForAllAdditional = '', useForAllEmergency = '';
            for (i = 0; i < passengersInfo.passengers.length; i++) {
                if (passengersInfo.passengers[i].additionalInfo.useForAll) {
                    useForAllAdditional = i;
                }
                if (passengersInfo.passengers[i].emergencyInfo.useForAll) {
                    useForAllEmergency = i;
                }
            }
            for (i = 0; i < passengersInfo.passengers.length; i++) {
                i = useForAllAdditional !== '' ? useForAllAdditional : i;
                passengerAvailable.push({ id: passengersInfo.passengers[i].id });
                additionalInfo.push({
                    id: passengersInfo.passengers[i].id
                });
                if (passengersInfo.passengers[i].gender !== passengersInfo.passengers[i].initialGender || passengersInfo.passengers[i].isRequiredGender) {
                    additionalInfo[i].gender = passengersInfo.passengers[i].gender === 'CHILD' ? null : passengersInfo.passengers[i].gender;
                }
                if (passengersInfo.passengers[i].additionalInfo.phone && passengersInfo.passengers[i].additionalInfo.phone !== '') {
                    additionalInfo[i].disruptionContact = {
                        language: (passengersInfo.passengers[i].additionalInfo.language) ? passengersInfo.passengers[i].additionalInfo.language : getAppMarket().toLowerCase(),
                        phone: {
                            countryCode: passengersInfo.passengers[i].additionalInfo.prefix,
                            number: passengersInfo.passengers[i].additionalInfo.phone
                        }
                    };
                }
                if (passengersInfo.passengers[i].additionalInfo.email && passengersInfo.passengers[i].additionalInfo.email !== '') {
                    additionalInfo[i].disruptionContact = angular.isUndefined(additionalInfo[i].disruptionContact) ? {} : additionalInfo[i].disruptionContact;
                    angular.extend(additionalInfo[i].disruptionContact, {
                        language: (passengersInfo.passengers[i].additionalInfo.language) ? passengersInfo.passengers[i].additionalInfo.language : getAppMarket().toLowerCase(),
                        email: passengersInfo.passengers[i].additionalInfo.email
                    });
                }
                if (passengersInfo.passengers[i].frequentFlyer && !passengersInfo.passengers[i].disableFfInfoData && passengersInfo.passengers[i].frequentFlyer.number != null && passengersInfo.passengers[i].frequentFlyer.number !== '') {
                    additionalInfo[i].frequentFlyer = {
                        iataCompanyCode: passengersInfo.passengers[i].frequentFlyer.iataCompanyCode,
                        number: passengersInfo.passengers[i].frequentFlyer.number
                    };
                }
                if (!additionalInfo[i].frequentFlyer && !additionalInfo[i].disruptionContact && !additionalInfo[i].gender) {
                    additionalInfo.splice(i, 1);
                }
                i = useForAllEmergency !== '' ? useForAllEmergency : i;
                emergencyInfo.push({
                    id: passengersInfo.passengers[i].id,
                    emergencyContact: {
                        refused: false,
                        name: passengersInfo.passengers[i].emergencyInfo.name,
                        phone: {
                            countryCode: passengersInfo.passengers[i].emergencyInfo.prefix,
                            number: passengersInfo.passengers[i].emergencyInfo.phone
                        }
                    }
                });

                if (!passengersInfo.passengers[i].additionalInfo.denyNewsLetters) {
                    newsLettersInfo.push({
                        email: passengersInfo.passengers[i].additionalInfo.email,
                        name: passengersInfo.passengers[i].name + ' ' + passengersInfo.passengers[i].surname,
                        departureCity: passengersInfo.segments[0].departure.airport.code,
                        destinationCity: passengersInfo.segments[0].arrival.airport.code,
                        language: CheckinAppConstants.lang,
                        country: CheckinAppConstants.market
                    });
                } else {
                    newsLettersInfo.push(null);
                }

            }
            return { additionalInfo: additionalInfo, emergencyInfo: emergencyInfo, newsLettersInfo: newsLettersInfo, passengerAvailable: passengerAvailable };
        }

        /**
         * Creates the additional info request based on allowed data to send by passenger, and indicates if the data needs to be updated with required info
         * @param {Object} bookingInfo  the whole booking information (cached Information)
         * @param {Array<Object>} additionalInfo the current additional info filled by the user
         * returns the request for additional info service filter by allowed data and a boolean if the information needs to be updated by the user
         */
        function filterAdditionalInfo (bookingInfo, additionalInfoData) {
            const addInfoFiltered = [];
            const additionalInfoOptions = [
                { id: 'GENDER', field: 'gender' },
                { id: 'CONTACT_DATA', field: 'disruptionContact' },
                { id: 'FREQUENT_FLYER', field: 'frequentFlyer' }
            ];
            const selectedPassengers = CommonsSessionStorageService.get('passengersSelected') || [];
            let pIndex, needsUpdate = false, aIndex = 0, pasFound = false, optionStatus;
            const additionalInfo = additionalInfoData || [];
            for (pIndex = 0; pIndex < bookingInfo.passengers.length; pIndex++) {
                pasFound = false, aIndex = 0;
                optionStatus = checkPassengerOptions(bookingInfo.passengers[pIndex], additionalInfoOptions);
                while (!pasFound && aIndex < additionalInfo.length) {
                    if (bookingInfo.passengers[pIndex].id === additionalInfo[aIndex].id) {
                        pasFound = true;
                        needsUpdate = needsUpdate || updatePassengerInfo(additionalInfo[aIndex], optionStatus.options);
                        if (additionalInfo[aIndex].gender || additionalInfo[aIndex].disruptionContact || additionalInfo[aIndex].frequentFlyer) {
                            addInfoFiltered.push(angular.copy(additionalInfo[aIndex]));
                        }
                    }
                    aIndex++;
                }
                if (!pasFound && selectedPassengers.indexOf(bookingInfo.passengers[pIndex].id) !== -1 && optionStatus.isSomethingRequired) {
                    needsUpdate = true;
                }
            }

            return {
                additionalInfo: addInfoFiltered,
                needsUpdate: needsUpdate
            };

            function checkPassengerOptions (passenger, options) {
                let oIndex, passengerOptions = { isSomethingRequired: false, options: {} };
                for (oIndex = 0; oIndex < options.length; oIndex++) {
                    passengerOptions.options[options[oIndex].id] = { field: options[oIndex].field };
                    passengerOptions.options[options[oIndex].id].isRequired = passenger.requiredInformation.indexOf(options[oIndex].id) !== -1;
                    passengerOptions.options[options[oIndex].id].isOptional = passenger.optionalInformation.indexOf(options[oIndex].id) !== -1;
                    passengerOptions.isSomethingRequired = passengerOptions.isSomethingRequired || passengerOptions.options[options[oIndex].id].isRequired;
                }
                return passengerOptions;
            }

            function updatePassengerInfo (passenger, optionsChecked) {
                let requiresUpdate = false, opt;
                for (opt in optionsChecked) {
                    if (!(optionsChecked[opt].isOptional || optionsChecked[opt].isRequired) && passenger[optionsChecked[opt].field]) {
                        delete passenger[optionsChecked[opt].field];
                    } else if (optionsChecked[opt].isRequired && !passenger[optionsChecked[opt].field]) {
                        requiresUpdate = true;
                    }
                }
                return requiresUpdate;
            }
        }

        /**
        * Return conditions of fareFamilyInfo
        * @param {Object} fareFamilyInfo Response of fareFamylyRest query
        * @return {Object} Conditions- Object with all conditions for diferents comercial codes
        */
        function setFareFamilyConditions (fareFamilyInfo) {
            let i, conditions = CommonsSessionStorageService.get('fareFamilyConditions') || {};
            fareFamilyInfo = fareFamilyInfo || [];
            for (i = 0; i < fareFamilyInfo.length; i++) {
                if (!conditions[fareFamilyInfo[i].commercialCode]) {
                    conditions[fareFamilyInfo[i].commercialCode] = fareFamilyInfo[i];
                }
            }
            CommonsSessionStorageService.set('fareFamilyConditions', conditions);
            return conditions;
        }


        /**
        * Return the company logo url in the project.
        * @param {String} companyCode -The company code
        * @returns {String} - the company logo url that matches with its company code in the data on localStorage
        */
        function getAirlineLogos (airlineCode) {
            const airlinesLogos = CommonsSessionStorageService.get('airlinesList');
            const airlineLogo = { companyURL: CheckinAppConstants.aerolinesLogoUrl + 'logo_pos_generico.svg', companyDisabledURL: CheckinAppConstants.aerolinesLogoUrl + 'logo_desact_generico.svg' };
            let aIndex, aux_iataCompanyCode;
            if (airlinesLogos && airlineCode && airlineCode !== '') {
                for (aIndex = 0; aIndex < airlinesLogos.length; aIndex++) {
                    aux_iataCompanyCode = airlinesLogos[aIndex].iataCompanyCode.split('-');
                    if (aux_iataCompanyCode[0] === airlineCode) {
                        airlineLogo[(aux_iataCompanyCode[1] !== 'dis' ? 'companyURL' : 'companyDisabledURL')] = CheckinAppConstants.aerolinesLogoUrl + airlinesLogos[aIndex].url;
                    }
                }
            }
            return airlineLogo;
        }

        function getCachedSelectedInfo (cachedData) {
            cachedData = cachedData || {};
            return getSelectedSegmentsInfo(cachedData.outwardSegments, cachedData.passengers)
                .concat(getSelectedSegmentsInfo(cachedData.returnSegments, cachedData.passengers))
                .concat(getSelectedSegmentsInfo(cachedData.airShuttleSegments, cachedData.passengers));

            function getSelectedSegmentsInfo (segments, passengersInfo) {
                const selectedSegments = [];
                let idSelectedSegments = CommonsSessionStorageService.get('availableSegments');
                let i, j, segmentFound;
                segments = segments || [];
                idSelectedSegments = idSelectedSegments || [];
                for (i = 0; i < segments.length; i++) {
                    segmentFound = false;
                    j = 0;
                    while (!segmentFound && j < idSelectedSegments.length) {
                        if (segments[i].id === idSelectedSegments[j]) {
                            segmentFound = true;
                            segments[i].passengers = getSelectedPassengersInfo(segments[i].passengers, passengersInfo);
                            selectedSegments.push(segments[i]);
                        }
                        j++;
                    }
                }
                return selectedSegments;
            }

            function getSelectedPassengersInfo (passengers, passengersInfo) {
                const selectedPassengers = [];
                let idSelectedPassengers = CommonsSessionStorageService.get('passengersSelected');
                let i, j, pasFound;
                passengers = passengers || [];
                idSelectedPassengers = idSelectedPassengers || [];
                for (i = 0; i < passengers.length; i++) {
                    pasFound = false;
                    j = 0;
                    while (!pasFound && j < idSelectedPassengers.length) {
                        if (passengers[i].id === idSelectedPassengers[j]) {
                            pasFound = true;
                            passengers[i] = getAllPassengerInformation(passengers[i], passengersInfo);
                            selectedPassengers.push(passengers[i]);
                        }
                        j++;
                    }
                }
                return selectedPassengers;
            }

            function getAllPassengerInformation (passenger, passengersInfo) {
                var passenger = passenger;
                let i = 0, found = false;
                passengersInfo = passengersInfo || [];
                while (!found && i < passengersInfo.length) {
                    if (passenger.id === passengersInfo[i].id) {
                        found = true;
                        passenger.extraInfo = passengersInfo[i];
                    }
                    i++;
                }
                return passenger;
            }
        }

        function getCabinClassName (cabinClassType) {
            let label = '';
            switch (cabinClassType) {//Switch case for input cabinClassType
                    case CheckinAppConstants.CABIN_CLASS_NAME.ECONOMY: label = 'CABINA_TURISTICA';
                        break;
                    case CheckinAppConstants.CABIN_CLASS_NAME.BUSINESS: label = 'CABINA_BUSINESS';
                        break;
                    case CheckinAppConstants.CABIN_CLASS_NAME.BUSINESS_PLUS: label = 'CABINA_BUSINESS';
                        break;
                    case CheckinAppConstants.CABIN_CLASS_NAME.BUSINESS_CLUB: label = 'CABINA_BUSINESS';
                        break;
                    case CheckinAppConstants.CABIN_CLASS_NAME.BUSINESS_CLASS: label = 'CABINA_BUSINESS';
                        break;
                    case CheckinAppConstants.CABIN_CLASS_NAME.PREMIUMTOURIST: label = 'CABINA_PREMIUM_TURIST';
                        break;
                    default: label = 'CABINA_TURISTICA';
                        break;
            }
            return label;
        }

        function isValidPassengerStatus (pasStatus) {
            return pasStatus === 'CHECKED' || pasStatus === 'CHECKABLE' || pasStatus === 'REISSUE'
                || pasStatus === 'STANDBY' || pasStatus === 'PENDING_AQQ' || pasStatus === 'PENDING_EVUS';
        }

        function getTripSegments (idSegments, cachedInfo) {
            const tripSegments = [];
            let i, j, segmentFound;
            idSegments = idSegments || [];
            for (i = 0; i < idSegments.length; i++) {
                segmentFound = false;
                j = 0;
                while (!segmentFound && j < cachedInfo.length) {
                    if (cachedInfo[j].id + '' === idSegments[i]) {
                        segmentFound = true;
                        if (cachedInfo[j].departure && cachedInfo[j].departure.date) {
                            cachedInfo[j].transformedDepartureDate = $filter('DateFormatFilter')(cachedInfo[j].departure.date);
                        }
                        tripSegments.push(cachedInfo[j]);
                    }
                    j++;
                }
            }
            return tripSegments;
        }

        function getMarketLabel () {
            let i = 0, found = false, marketLabel = '';
            const marketArray = CheckinAppConstants.markets;
            while (!found && i < marketArray.length) {
                if (CheckinAppConstants.market === marketArray[i].code) {
                    marketLabel = marketArray[i].description;
                    found = true;
                }
                i++;
            }
            return marketLabel;
        }

        function getSSOErrorCodeMessage (errorCode) {
            let message = '';
            switch (errorCode) {
                    case '606': message = $filter('translate')('ERROR_SSO_606'); break;
                    case '302': message = $filter('translate')('ERROR_SSO_302'); break;
                    case '609': message = $filter('translate')('ERROR_SSO_609'); break;
                    default: message = $filter('translate')('REST_SERVICE_ERROR_GENERAL');
            }
            return message;
        }

        function isPassengerSelected (passengerId) {
            const idSelectedPassengers = CommonsSessionStorageService.get('passengersSelected');
            return idSelectedPassengers && idSelectedPassengers.indexOf(passengerId) !== -1;
        }

        function validLuhnCompanyCard (ccNum) {
            let arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
                len = ccNum.length,
                bit = 1,
                sum = 0,
                val;
            while (len) {
                val = parseInt(ccNum.charAt(--len), 10);
                sum += (bit ^= 1) ? arr[val] : val;
            }
            return sum && sum % 10 === 0;
        }

        function updateSegmentCabinClass (segmentId, cabinClassType) {
            const bookingInfo = CommonsSessionStorageService.get('bookingInfo');
            let i = 0, found = false;
            while (!found && i < bookingInfo.outwardSegments.length) {
                if (bookingInfo.outwardSegments[i].id === segmentId) {
                    found = true;
                    bookingInfo.outwardSegments[i].cabinClass.type = cabinClassType;
                }
                i++;
            }
            i = 0;
            while (!found && i < bookingInfo.returnSegments.length) {
                if (bookingInfo.returnSegments[i].id === segmentId) {
                    found = true;
                    bookingInfo.returnSegments[i].cabinClass.type = cabinClassType;
                }
                i++;
            }
            CommonsSessionStorageService.set('bookingInfo', bookingInfo);
        }

        /**
         * Clean data in localStorage
         */
        function initStorage () {
            //Clear other app storage
            CommonsSessionStorageService.clearAll(/(?!(ib-check-in-app).*)^(ib-[\w\-]+-app\.[\w\-]+)/i, { withPrefix: false });
            CommonsSessionStorageService.remove('ancillariesInfo');
            CommonsSessionStorageService.remove('selectedSegments');
            CommonsSessionStorageService.remove('ancillariesSeatInfo');
            CommonsSessionStorageService.remove('currency');
            CommonsSessionStorageService.remove('disruptionContactApis');
            CommonsSessionStorageService.remove('ancillariesTransformedInfo');
            CommonsSessionStorageService.remove('userLoggedBookingInfo');
            CommonsSessionStorageService.remove('NivelUsuario');
            CommonsSessionStorageService.remove('userID');
            CommonsSessionStorageService.remove('printBoardingCards');
            CommonsSessionStorageService.remove('additionalInfoPa');
            CommonsSessionStorageService.remove('selectInsurance');
            CommonsSessionStorageService.remove('hasSelectedInsurance');
            CommonsSessionStorageService.remove('hasSelectedBaggage');
            CommonsSessionStorageService.remove('counterDocs');
            CommonsSessionStorageService.remove('selectedLoggedCard');
            CommonsSessionStorageService.remove('flowPages');
            CommonsSessionStorageService.remove('issuedItems');
            CommonsSessionStorageService.remove('gdprInfo');
            CommonsSessionStorageService.remove('segmentsBaggageSelected');
            CommonsSessionStorageService.remove('isFirstEarlyMap');
            CommonsSessionStorageService.remove('tripsChanged');
            CommonsSessionStorageService.remove('insuranceSelected');
            CommonsSessionStorageService.remove('seatMapSegment');
            CommonsSessionStorageService.remove('selectedInsurance');
            CommonsSessionStorageService.remove('seatInfoConfirmation');
            CommonsSessionStorageService.remove('passengersContactData');
            CommonsSessionStorageService.remove('segmentsSelected');
            CommonsSessionStorageService.remove('passengersNOAPIS');
            CommonsSessionStorageService.remove('bookingInfo');
            CommonsSessionStorageService.remove('headerModel');
            CommonsSessionStorageService.remove('breakDownInfo');
            CommonsSessionStorageService.remove('passengerBaggagesTrips');
            CommonsSessionStorageService.remove('passengerSpeqsTrips');
            CommonsSessionStorageService.remove('ancillariesAvailableSegments');
            CommonsSessionStorageService.remove('isPaFlow');
            CommonsSessionStorageService.remove('pendingPayments');
            CommonsSessionStorageService.remove('flightConfirmationNeedsCheckin');
            CommonsSessionStorageService.remove('modelPaymentData');
            CommonsSessionStorageService.remove('issueOrderInfo');
            CommonsSessionStorageService.remove('paymentMethodsWithoutDiscount');
            CommonsSessionStorageService.remove('fullIssuedPaiment');
            CommonsSessionStorageService.remove('typeCardSelected');
            CommonsSessionStorageService.remove('redirectionPaymentCallback');
            CommonsSessionStorageService.remove('birthDate');
            CommonsSessionStorageService.remove('ancillariesSlices');
            CommonsSessionStorageService.remove('nextStepAllowed');
            CommonsSessionStorageService.remove('noShowMessageBockBack');
            CommonsSessionStorageService.remove('flowId');
            CommonsSessionStorageService.remove('confirmationInfo');
            CommonsSessionStorageService.remove('biometricBoardingAssociation');
            CommonsSessionStorageService.remove('biometricBoardingAssociationSuccess');
            CommonsSessionStorageService.remove('showBiometric');
            CommonsSessionStorageService.remove('biometricUserNotInterested');
            CommonsSessionStorageService.remove('biometricSomeComplete');
            CommonsSessionStorageService.remove('addEarlyChecking');
            CommonsSessionStorageService.remove('earlyCheckinCode');
            CommonsSessionStorageService.remove('bobInfo');
            CommonsSessionStorageService.remove('bobOrder');
            CommonsSessionStorageService.remove('segmentsInfo');
            CommonsSessionStorageService.remove('bobFormModel');
            CommonsSessionStorageService.remove('frequentFlyerBOB');
            CommonsSessionStorageService.remove('headerInfo');
            CommonsSessionStorageService.remove('showBasket');
            CommonsSessionStorageService.remove('lastFieldBob');
            CommonsSessionStorageService.remove('specialUserBob');
            CommonsSessionStorageService.remove('upgradinfInfoAccepted');
            CommonsSessionStorageService.remove('summaryAncillaries');
            CommonsSessionStorageService.remove('acceptInfoSegments');
            CommonsSessionStorageService.remove('upgradeInfo');
            CommonsSessionStorageService.remove('isCheckedAllPassengers');
            CommonsSessionStorageService.remove('selectedPriorityBoarding');
            CommonsSessionStorageService.remove('totalPricePriorityBoarding');
            CommonsSessionStorageService.remove('inhibitBoardingCard');
            CommonsSessionStorageService.remove('usTracing');
            CommonsSessionStorageService.remove('isFlowDuplicated');
            CommonsSessionStorageService.remove('globick_transfercki');
            CommonsSessionStorageService.remove('globick_activitiescki');
            CommonsSessionStorageService.remove('widgetProMonetate');
            CommonsSessionStorageService.remove('addToCart');
            CommonsSessionStorageService.remove('isEarly');
            CommonsSessionStorageService.remove('inhibitionBC');
            CommonsSessionStorageService.remove('summaryTripForUpg');
            CommonsSessionStorageService.remove('newSeatsMap');
            CommonsSessionStorageService.remove('oldSeatsConfig');
            CommonsSessionStorageService.remove('longHaulAircrafts');
            CommonsSessionStorageService.remove('seatMapTourAircrafts');
            CommonsSessionStorageService.remove('currentSeatmapData');
            CommonsSessionStorageService.remove('aircraftSeatMapVR');
            CommonsSessionStorageService.remove('upgSlices');
            CommonsSessionStorageService.remove('totalPriceFormatted');
            CommonsSessionStorageService.remove('posOfferPriceFormatted');
            CommonsSessionStorageService.remove('showPriceCombinated');
            CommonsSessionStorageService.remove('passengersApisDocs');
            CommonsSessionStorageService.remove('alreadyLoaded');
            DatalayerUniqueKeysService.clear();
            if (!isUserLogged()) {
                CommonsSessionStorageService.remove('customerData');
            }
        }


        function checkConfirmationPNR () {
            const confirmationPNR = CommonsSessionStorageService.get('confirmationPNR');
            if (confirmationPNR) {
                $location.path(CommonsSessionStorageService.get('userLogged') ? '/ibcose2' : '/ibcose');
            }
            return confirmationPNR;
        }

        /**
         * Returns the value for the html metatag given.
         * @param {string} metaTagName - The metatag name for get the value
         * @returns {string} - The metatag value for the given metaTagName
         */
        function getMetaTagValueByName (metaTagName) {
            let value = '';
            if (metaTagName && angular.isString(metaTagName) && $window.document.getElementsByName(metaTagName).length > 0) {
                value = $window.document.getElementsByName(metaTagName)[0].content;
            }
            return value;
        }

        function saveEndpoints (endpointsData) {
            const endpoints = {};
            let i;
            for (i = 0; i < endpointsData.length; i++) {
                endpoints[endpointsData[i].key] = endpointsData[i].host + endpointsData[i].basePath;
            }
            CommonsSessionStorageService.set('endpoints', endpoints);
        }

        function getEndpoint (key) {
            return (CommonsSessionStorageService.get('endpoints') || {})[key];
        }

        function updateSelectedSegments (selectedSegment, newBookingInfo) {
            let i, j;
            const newSelectedIds = [];
            const checkablePassengers = [];
            let isAllowed = false;
            for (i = 0; i < newBookingInfo.airShuttleSegments.length; i++) {
                if (selectedSegment.departureDateTime === newBookingInfo.airShuttleSegments[i].departure.date && selectedSegment.arrivalDateTime === newBookingInfo.airShuttleSegments[i].arrival.date) {
                    newSelectedIds.push(newBookingInfo.airShuttleSegments[i].id);
                    for (j = 0; j < newBookingInfo.airShuttleSegments[i].passengers.length; j++) {
                        if (isValidPassengerStatus(newBookingInfo.airShuttleSegments[i].passengers[j].status.code)) {
                            isAllowed = true;
                            checkablePassengers.push(newBookingInfo.airShuttleSegments[i].passengers[j].id);
                        }
                    }
                }
            }
            CommonsSessionStorageService.set('passengersSelected', checkablePassengers);
            return { isAllowed: isAllowed, newSegmentsId: newSelectedIds, checkablePassengers: checkablePassengers };
        }

        function updateCachedInfo (acceptData) {
            const cachedInfo = CommonsSessionStorageService.get('bookingInfo');
            const uncheckableSegments = [];
            let i, j, k, l, segmentFound, pasFound;
            acceptData = acceptData || [];
            for (i = 0; i < acceptData.length; i++) {
                j = 0, segmentFound = false;
                while (!segmentFound && j < cachedInfo.outwardSegments.length) {
                    if (acceptData[i].id === cachedInfo.outwardSegments[j].id) {
                        segmentFound = true;
                        cachedInfo.outwardSegments[j].cabinClass = acceptData[i].cabinClass || cachedInfo.outwardSegments[j].cabinClass;
                        for (k = 0; k < acceptData[i].passengers.length; k++) {
                            pasFound = false, l = 0;
                            while (!pasFound && l < cachedInfo.outwardSegments[j].passengers.length) {
                                if (acceptData[i].passengers[k].id === cachedInfo.outwardSegments[j].passengers[l].id) {
                                    pasFound = true;
                                    cachedInfo.outwardSegments[j].passengers[l].seat = acceptData[i].passengers[k].seat;
                                    cachedInfo.outwardSegments[j].passengers[l].status.code = acceptData[i].passengers[k].status;
                                    if (acceptData[i].passengers[k].status === 'UNCHECKABLE' && uncheckableSegments.indexOf(acceptData[i].id) === -1) {
                                        uncheckableSegments.push(acceptData[i].id);
                                    }
                                }
                                l++;
                            }
                        }
                    }
                    j++;
                }
                j = 0;
                while (!segmentFound && j < cachedInfo.returnSegments.length) {
                    if (acceptData[i].id === cachedInfo.returnSegments[j].id) {
                        segmentFound = true;
                        cachedInfo.returnSegments[j].cabinClass = acceptData[i].cabinClass || cachedInfo.returnSegments[j].cabinClass;
                        for (k = 0; k < acceptData[i].passengers.length; k++) {
                            pasFound = false, l = 0;
                            while (!pasFound && l < cachedInfo.returnSegments[j].passengers.length) {
                                if (acceptData[i].passengers[k].id === cachedInfo.returnSegments[j].passengers[l].id) {
                                    pasFound = true;
                                    cachedInfo.returnSegments[j].passengers[l].seat = acceptData[i].passengers[k].seat;
                                    cachedInfo.returnSegments[j].passengers[l].status.code = acceptData[i].passengers[k].status;
                                    if (acceptData[i].passengers[k].status === 'UNCHECKABLE' && uncheckableSegments.indexOf(acceptData[i].id) === -1) {
                                        uncheckableSegments.push(acceptData[i].id);
                                    }
                                }
                                l++;
                            }
                        }
                    }
                    j++;
                }
                j = 0;
                while (!segmentFound && j < cachedInfo.airShuttleSegments.length) {
                    if (acceptData[i].id === cachedInfo.airShuttleSegments[j].id) {
                        segmentFound = true;
                        cachedInfo.airShuttleSegments[j].cabinClass = acceptData[i].cabinClass || cachedInfo.airShuttleSegments[j].cabinClass;
                        for (k = 0; k < acceptData[i].passengers.length; k++) {
                            pasFound = false, l = 0;
                            while (!pasFound && l < cachedInfo.airShuttleSegments[j].passengers.length) {
                                if (acceptData[i].passengers[k].id === cachedInfo.airShuttleSegments[j].passengers[l].id) {
                                    pasFound = true;
                                    cachedInfo.airShuttleSegments[j].passengers[l].seat = acceptData[i].passengers[k].seat;
                                    cachedInfo.airShuttleSegments[j].passengers[l].status.code = acceptData[i].passengers[k].status;
                                    if (acceptData[i].passengers[k].status === 'UNCHECKABLE' && uncheckableSegments.indexOf(acceptData[i].id) === -1) {
                                        uncheckableSegments.push(acceptData[i].id);
                                    }
                                }
                                l++;
                            }
                        }
                    }
                    j++;
                }
            }
            CommonsSessionStorageService.set('bookingInfo', cachedInfo);
            return uncheckableSegments;
        }

        /**
         * check if the current user is logged or not
         * @return true if the user is logged in the app
         */
        function isUserLogged () {
            return CommonsSessionStorageService.get('userLogged');
        }

        /**
         * Clean the spaces on string
         * @param {String} str
         */
        function cleanSpaces (str) {
            return str = str.replace(/^\s+|\s+$/gm, '');
        }

        /**
        * Return date with slash separator
        * @param {Object} date Object with date values
        * @return {String} Date formated with slash separator
        */
        function getSlashDate (date) {
            let dateSlice = '';
            if (date) {
                dateSlice = (date.monthDay < 10 ? '0' + date.monthDay : date.monthDay) + '/' + (date.monthNumber < 10 ? '0' + date.monthNumber : date.monthNumber) + '/' + date.year;
            }
            return dateSlice;
        }

        /**
        * Return date with slash separator
        * @param {Object} date Object with date values
        * @return {String} Date formated with slash separator
        */
        function getMiddleDashDate (date) {
            let dateSlice = '';
            if (date) {
                dateSlice = date.year + '-' + (date.monthNumber < 10 ? '0' + date.monthNumber : date.monthNumber) + '-' + (date.monthDay < 10 ? '0' + date.monthDay : date.monthDay);
            }
            return dateSlice;
        }

        function generateUpdateSeatsMap (updateInfo) {
            const update = [{ type: CheckinAppConstants.SeatTypes.seat, segments: [] }];
            let i, segment = { id: null, passengers: [] }, aux = null;
            for (i = 0; i < updateInfo.length; i++) {
                aux = { id: null, seat: { row: null, column: null } };
                aux.id = updateInfo[i].id;
                updateInfo[i].seat ? aux.seat = updateInfo[i].seat : aux.seat = null;
                segment.id = CommonsSessionStorageService.get('seatMapSegment').segmentId;
                segment.passengers.push(aux);
            }
            update[0].segments.push(segment);
            return update;
        }

        function updateCachedInformation (update, segmentId) {
            const cachedInfo = CommonsSessionStorageService.get('bookingInfo');
            const updateInfo = update[0].segments[0].passengers;
            let j = 0, k, l, segmentFound = false, pasFound;
            while (!segmentFound && j < cachedInfo.outwardSegments.length) {
                if (segmentId === cachedInfo.outwardSegments[j].id) {
                    segmentFound = true;
                    for (k = 0; k < updateInfo.length; k++) {
                        pasFound = false, l = 0;
                        while (!pasFound && l < cachedInfo.outwardSegments[j].passengers.length) {
                            if (updateInfo[k].id === cachedInfo.outwardSegments[j].passengers[l].id) {
                                pasFound = true;
                                cachedInfo.outwardSegments[j].passengers[l].seat = updateInfo[k].seat;
                            }
                            l++;
                        }
                    }
                }
                j++;
            }
            j = 0;
            while (!segmentFound && j < cachedInfo.returnSegments.length) {
                if (segmentId === cachedInfo.returnSegments[j].id) {
                    segmentFound = true;
                    for (k = 0; k < updateInfo.length; k++) {
                        pasFound = false, l = 0;
                        while (!pasFound && l < cachedInfo.returnSegments[j].passengers.length) {
                            if (updateInfo[k].id === cachedInfo.returnSegments[j].passengers[l].id) {
                                pasFound = true;
                                cachedInfo.returnSegments[j].passengers[l].seat = updateInfo[k].seat;
                            }
                            l++;
                        }
                    }
                }
                j++;
            }
            j = 0;
            while (!segmentFound && j < cachedInfo.airShuttleSegments.length) {
                if (segmentId === cachedInfo.airShuttleSegments[j].id) {
                    segmentFound = true;
                    for (k = 0; k < updateInfo.length; k++) {
                        pasFound = false, l = 0;
                        while (!pasFound && l < cachedInfo.airShuttleSegments[j].passengers.length) {
                            if (updateInfo[k].id === cachedInfo.airShuttleSegments[j].passengers[l].id) {
                                pasFound = true;
                                cachedInfo.airShuttleSegments[j].passengers[l].seat = updateInfo[k].seat;
                            }
                            l++;
                        }
                    }
                }
                j++;
            }
            CommonsSessionStorageService.set('bookingInfo', cachedInfo);
        }
        /**
         * Return first segment with pending seats
         * @return {Object} Segment
         */
        function getSegmentSeatsPending () {
            let i = 0, isFound = false, segmentsPending = CommonsSessionStorageService.get('pendingSegmentSeats') || [], segment = null;
            while (!isFound && i < segmentsPending.length) {
                if (!segmentsPending[i].isCompleted) {
                    segment = segmentsPending[i];
                    isFound = true;
                }
                i++;
            }
            if (segment) {
                if (segmentsPending[segmentsPending.length - 1].segmentId === segment.segmentId) {
                    segment.isLast = true;
                }
            }


            return segment;
        }

        /**
        * Update segment seat in localStorage
        * @param {Array} passsengersUpdated List of passenger updated on segment
        * @param {Integer} segmentId Segmet to update seats
        */
        function updateSegmentSeatStatus (passsengersUpdated, segmentId) {
            let i, isFound = false, segmentsPending = CommonsSessionStorageService.get('pendingSegmentSeats');
            angular.forEach(segmentsPending, (segment) => {
                isFound = false, i = 0;
                while (!isFound && i < passsengersUpdated.length) {
                    if (segment.segmentId === segmentId) {
                        if (segment.pasId === passsengersUpdated[i].id) {
                            isFound = true;
                            segment.isCompleted = true;
                        }
                    }
                    i++;
                }
            });
            CommonsSessionStorageService.set('pendingSegmentSeats', segmentsPending);
        }


        /**
         * Check if flown is early or not
         * @param {*} passengersSelected
         */
        function checkEarlySegments (passengers, segmentsSelected) {
            let restBookingInfo = CommonsSessionStorageService.get('bookingInfo'), i = 0, k, isEarlyFlow = false;
            var segmentsSelected = segmentsSelected || CommonsSessionStorageService.get('segmentsSelected');
            let pendingSegmentsSeat = [], segment, listSegmentsSelected = [], passengersSelected = [];

            angular.forEach(segmentsSelected, (segment) => {
                if (segment.isSelected) listSegmentsSelected.push(segment.id);
            });


            angular.forEach(passengers, (pas) => {
                if (pas.isSelected) passengersSelected.push(pas.id);
            });


            isEarlyFlow = angular.toJson(listSegmentsSelected) === angular.toJson(restBookingInfo.checkinSegmentsInGroup);

            if (isEarlyFlow) {
                while (i < restBookingInfo.checkinSegmentsInGroup.length) {
                    for (k = 0; k < restBookingInfo.outwardSegments.length; k++) {
                        if (restBookingInfo.checkinSegmentsInGroup[i] === restBookingInfo.outwardSegments[k].id) {
                            angular.forEach(restBookingInfo.outwardSegments[k].passengers, (pas) => {
                                if (!pas.seat && (CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.NOT_AVAILABLE.indexOf(pas.status.code) === -1 && passengersSelected.indexOf(pas.id) !== -1)) {
                                    segment = { segmentId: restBookingInfo.outwardSegments[k].id, pasId: pas.id, isCompleted: false, isLast: false };
                                    pendingSegmentsSeat.push(segment);
                                }
                            });
                        }
                    }
                    for (k = 0; k < restBookingInfo.returnSegments.length; k++) {
                        if (restBookingInfo.checkinSegmentsInGroup[i] === restBookingInfo.returnSegments[k].id) {
                            angular.forEach(restBookingInfo.returnSegments[k].passengers, (pas) => {
                                if (!pas.seat && (CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.NOT_AVAILABLE.indexOf(pas.status.code) === -1 && passengersSelected.indexOf(pas.id) !== -1)) {
                                    segment = { segmentId: restBookingInfo.returnSegments[k].id, pasId: pas.id, isCompleted: false, isLast: false };
                                    pendingSegmentsSeat.push(segment);
                                }
                            });
                        }
                    }
                    i++;
                }
                if (CommonsSessionStorageService.get('isFirstEarlyMap') === null) {
                    CommonsSessionStorageService.set('isFirstEarlyMap', true);
                }

            }
            CommonsSessionStorageService.set('pendingSegmentSeats', pendingSegmentsSeat);


            return isEarlyFlow;
        }

        /*
         * @return {BOOL} TRUE if have and FALSE if not
         * @param {Object} bookingInfo Booking information returned by service
         * @param {Object} selectedSegments Ancillaries information returned by service
         */
        function checkEarlyFlights (bookingInfo, selectedSegments) {
            let isEarly = false;
            angular.forEach(selectedSegments, (segmentId) => {
                angular.forEach(bookingInfo.checkinSegmentsInGroup, (earlySegmentId) => {
                    if (earlySegmentId === segmentId) {
                        isEarly = true;
                    }
                });
            });
            return isEarly;
        }

        /**
         * Redirect to ibcose page
         */
        function goIbCose () {
            $window.location = $window.location.pathname + $window.location.search;
        }
        /**
         * Check if company is IB|I2|YW
         * @param {String} company Company of flight
         */
        function checkCompany (company) {
            return company === CheckinAppConstants.COMPANIES.IB || company === CheckinAppConstants.COMPANIES.I2 || company === CheckinAppConstants.COMPANIES.YW;
        }


        /**
       * Generate infoheader object, save in localStorage and return it
       * @param {Array} segments Information of segments
       * @param {Array} passengers  Information of passengers
       */
        function getInfoHeader (segments, passengers) {
            let modelHeader = [],
                segmentInfo = {};
            getSegmentsInfo();


            segments.forEach((segment) => {
                segmentInfo = {
                    originCity: {},
                    destinationCity: {},
                    dates: {},
                    passengers: 0,
                    numAdults: 0,
                    numSeniors: 0,
                    numYoung: 0,
                    numTeenager: 0,
                    numInfant: 0,
                    numChilds: 0,
                    numberPassengrsWithoutInfant: 0
                };
                segmentInfo.originCity = originCityInfo(segment.departure);
                segmentInfo.destinationCity = destinationCityInfo(segment.arrival);
                segmentInfo.dates = dateFlightInfo(segment.departure);
                passengers.forEach((passenger) => {
                    switch (passenger.type) {
                            case CheckinAppConstants.PASSENGER_TYPE.SENIOR:
                                segmentInfo.numSeniors += 1;
                                break;
                            case CheckinAppConstants.PASSENGER_TYPE.ADULT:
                                segmentInfo.numAdults += 1;
                                break;
                            case CheckinAppConstants.PASSENGER_TYPE.CHILD:
                                segmentInfo.numChilds += 1;
                                break;
                            case CheckinAppConstants.PASSENGER_TYPE.INFANT:
                                segmentInfo.numInfant += 1;
                                break;
                            case CheckinAppConstants.PASSENGER_TYPE.YOUTH:
                                segmentInfo.numYoung += 1;
                                break;
                    }
                    if (passenger.infant === null) {
                        segmentInfo.numberPassengrsWithoutInfant += 1;
                    }
                });
                segmentInfo.passengers = passengers.length;
                modelHeader.push(segmentInfo);
            });


            return modelHeader;
            function originCityInfo (departure) {
                return {
                    code: departure.airportCode,
                    description: departure.airportCode,
                    timezone: '',
                    country: {
                        code: '',
                        description: ''
                    }
                };
            }
            function destinationCityInfo (arrival) {
                return {
                    code: arrival.airportCode,
                    description: arrival.airportCode,
                    timezone: '',
                    country: {
                        code: '',
                        description: ''
                    }
                };
            }
            function dateFlightInfo (departure) {
                return {
                    outboundFlight: getMiddleDashDate(departure.date),
                    formatedOutboundFlight: getMiddleDashDate(departure.date) + 'T00:00:00.000Z',
                    returnFlight: '',
                    formatedReturnFlight: ''
                };
            }
        }


        /**
         * Return information of segment for common-header
         * @param {Array} segments List of segment of booking
         */
        function generateHeaderTripsInfo () {
            let flight, trips = [], bookingInfo = CommonsSessionStorageService.get('bookingInfo');

            bookingInfo.airShuttleSegments.forEach((segment) => {
                if (segment.type !== CheckinAppConstants.SHUTTLE_SEGMENTS_TYPES.OPEN) {
                    flight = { originCode: segment.departure.airport.code, destinyCode: segment.arrival.airport.code, dateFlight: getSlashDate($filter('DateFormatFilter')(segment.departure.date.split(' ')[0])) };
                    trips.push(flight);
                }
            });

            bookingInfo.outwardSegments.forEach((segment) => {
                flight = { originCode: segment.departure.airport.code, destinyCode: segment.arrival.airport.code, dateFlight: getSlashDate($filter('DateFormatFilter')(segment.departure.date.split(' ')[0])) };
                trips.push(flight);
            });

            bookingInfo.returnSegments.forEach((segment) => {
                flight = { originCode: segment.departure.airport.code, destinyCode: segment.arrival.airport.code, dateFlight: getSlashDate($filter('DateFormatFilter')(segment.departure.date.split(' ')[0])) };
                trips.push(flight);
            });

            return trips;
        }

        /**
         * Generate information of upgrading for common header
         * @param {Array} ancillaries Information of ancillaries pending to pay returned by basket service
         * @return {Object} upgradingInfo Information of upgrading  segments selected by user
         */
        function getHeadeUpgradingInfo (ancillaries) {
            let segments = getSegmentsInfo(), upgradingInfo = { upgradingTrips: [], total: null, totalFormatted: null }, trip, isFound, k, i, currency = CurrencyService.getCurrencyObject(CommonsSessionStorageService.get('upgradeInfo').currency);

            angular.forEach(ancillaries, (ancillarie) => {
                if (ancillarie.type === CheckinAppConstants.ANCILLARIES_TYPES.UPGRADING) {
                    angular.forEach(ancillarie.upgrading.offerSegmentsClass, (segment) => {
                        trip = { segmentId: segment.segmentId, cabin: segment.cabinClass.description, origin: null, destination: null };
                        upgradingInfo.upgradingTrips.push(trip);

                    });
                    upgradingInfo.total = ancillarie.total;
                    upgradingInfo.totalFormatted = CurrencyService.formatPrice(currency, upgradingInfo.total, true);

                    for (i = 0; i < upgradingInfo.upgradingTrips.length; i++) {
                        k = 0; isFound = false;
                        while (!isFound && k < segments.length) {
                            if (upgradingInfo.upgradingTrips[i].segmentId === segments[k].id) {
                                upgradingInfo.upgradingTrips[i].origin = segments[k].origin;
                                upgradingInfo.upgradingTrips[i].destination = segments[k].destination;
                                isFound = true;
                            }
                            k++;
                        }
                    }
                }
            });
            return upgradingInfo;
        }

        /**
         * Given the array, creates an object that has one property for each kind of parameter found in the array
         * @param {*} array initial array to be transformed
         * @param {*} parameter string that defines which property of each element we will use to create the new object
         * @param {*} canBeRepeated boolean that tells if each parameter can have more than one element of the initial array.
         * @returns {*} transformedObject
         */
        function getElementsByProperty (array, parameter, canBeRepeated) {
            let transformedObject = {}, i;
            if (canBeRepeated) {
                for (i = 0; i < array.length; i++) {
                    transformedObject[array[i][parameter]] = transformedObject[array[i][parameter]] || [];
                    transformedObject[array[i][parameter]].push(array[i]);
                }
            } else {
                for (i = 0; i < array.length; i++) {
                    transformedObject[array[i][parameter]] = array[i];
                }
            }
            return transformedObject;
        }

        /**
         * Return segments on booking
         * @return {Array} List of segments on booking with basic information
         */
        function getSegmentsInfo () {
            let bookingInfo = CommonsSessionStorageService.get('bookingInfo'), i, segments = CommonsSessionStorageService.get('segmentsInfo') || [], segment;

            for (i = 0; i < bookingInfo.outwardSegments.length; i++) {
                segment = {
                    id: bookingInfo.outwardSegments[i].id.toString(),
                    origin: {
                        description: bookingInfo.outwardSegments[i].departure.airport.description,
                        code: bookingInfo.outwardSegments[i].departure.airport.code
                    },
                    destination: {
                        description: bookingInfo.outwardSegments[i].arrival.airport.description,
                        code: bookingInfo.outwardSegments[i].arrival.airport.code
                    }
                };
                segments.push(segment);
            }

            for (i = 0; i < bookingInfo.returnSegments.length; i++) {
                segment = {
                    id: bookingInfo.returnSegments[i].id.toString(),
                    origin: {
                        description: bookingInfo.returnSegments[i].departure.airport.description,
                        code: bookingInfo.returnSegments[i].departure.airport.code
                    },
                    destination: {
                        description: bookingInfo.returnSegments[i].arrival.airport.description,
                        code: bookingInfo.returnSegments[i].arrival.airport.code
                    }
                };
                segments.push(segment);

            }

            for (i = 0; i < bookingInfo.airShuttleSegments.length; i++) {
                segment = {
                    id: bookingInfo.airShuttleSegments[i].id.toString(),
                    origin: {
                        description: bookingInfo.airShuttleSegments[i].departure.airport.description,
                        code: bookingInfo.airShuttleSegments[i].departure.airport.code
                    },
                    destination: {
                        description: bookingInfo.airShuttleSegments[i].arrival.airport.description,
                        code: bookingInfo.airShuttleSegments[i].arrival.airport.code
                    }
                };
                segments.push(segment);

            }

            CommonsSessionStorageService.set('segmentsInfo', segments);
            return segments;
        }
        /**
         * Return url to show backgrond payment while loading payment
         */
        function getPaymentsBackGroundURL () {
            let backgroundURL, widthScreen = $window.innerWidth > 1024 ? 2000 : ($window.innerWidth > 480 && $window.innerWidth < 1025) ? 768 : $window.innerWidth < 481 ? 320 : 2000;
            backgroundURL = '/background/generico/disponibilidad_default_' + widthScreen + '.jpg';
            return backgroundURL;
        }

        /**
         * Set in localstorage the currency for show prices
         * @param {Array} currencies List of currencies available returned by service
         * @param {String} issueCurrency  Code of currency for set in localStorage
         */
        function setAncillariesCurrency (currencies, issueCurrency) {
            let i = 0, isFound = false;
            while (i < currencies.length && !isFound) {
                if (currencies[i].code === issueCurrency) {
                    CommonsSessionStorageService.set('currency', CurrencyService.getCurrencyObject(currencies[i]));
                    isFound = true;
                }
                i++;
            }
        }

        /*
         * Warns the user when browser back button is pressed and gives him/her the option of staying in the page or leaving to the homepage.
         */
        function warnUserOnBackPressed (history, window, location, angular, closeModal) {
            history.pushState(null, null, location.href);
            window.onpopstate = function () {
                let modalObject;
                const endpoint = (location.href).substr(-6, 6);
                const blockBack = CommonsSessionStorageService.get('nextStepAllowed');
                const contNextStep = CommonsSessionStorageService.get('contNextStep');
                const noShowMessageBockBack = CommonsSessionStorageService.get('noShowMessageBockBack');
                const errorCarrierConnect = CommonsSessionStorageService.get('errorCarrierConnect');
                const softUserAfterLogin = CommonsSessionStorageService.get('softUserAfterLogin');
                const inhibitionBC = CommonsSessionStorageService.get('inhibitionBC');
                if (endpoint === 'ckianc') {
                    CommonsSessionStorageService.set('invokeEarlyCheckinFunction', true);
                } else {
                    CommonsSessionStorageService.set('invokeEarlyCheckinFunction', false);
                }
                if (endpoint === 'ibcose' && blockBack === false && contNextStep > 1) {
                    closeModal();
                    $window.location.href = $window.location.origin;
                } else if (softUserAfterLogin === 'true') {
                    CommonsSessionStorageService.remove('softUserAfterLogin');
                } else {
                    if (noShowMessageBockBack === true || (noShowMessageBockBack === false && errorCarrierConnect === true)) {
                        if(inhibitionBC === null || !inhibitionBC) {
                            CommonsSessionStorageService.set('noShowMessageBockBack', false);
                            CommonsSessionStorageService.set('nextStepAllowed', true);
                            CommonsSessionStorageService.set('errorCarrierConnect', false);
                        }
                    } else {
                        if (blockBack) {
                            closeModal();
                            modalObject = {
                                title: {
                                    message: 'CKIANCPURC_MODAL_TARJ_TITLE',
                                    needsTranslate: true
                                },
                                needsTranslate: true,
                                message: 'NOT_ALLOWED_FLOW_STEP_TEXT_CKI'
                            };
                            ModalService.openNavigationErrorModal(modalObject, true).result.then(history.pushState(null, null, location.href), angular.noop);
                        }
                    }
                }
            };
        }

        /*
         * Clean status payment from URL
         */
        function removeParameterURL (url) {
            return (url.replace('paymentStatus=OK', '')).replace('paymentStatus=KO', '');
        }

        /*
         * Save data of ancillaries summary to set BOB local variable
         */

        function setAncillariesBob (freeItems) {
            let bobOrder = null, contactApi = CommonsSessionStorageService.get('disruptionContactApis');
            angular.forEach(freeItems, (item) => {
                if (item.type === CheckinAppConstants.ANCILLARIES_TYPES.INTEGRATED_BOB) {
                    bobOrder = {
                        id: item.orderId,
                        status: item.status,
                        bookingCode: item.bookingCode,
                        summary: [{
                            number: null,
                            type: null,
                            status: item.status,
                            amount: item.total,
                            products: [{ type: 'checkin', quantity: item.bags, price: item.total, tax: 0 }],
                            date: null,
                            slot: null,
                            address: null,
                            email: contactApi[0].disruptionContact.email.toUpperCase()
                        }]
                    };
                }
            });
            if (bobOrder) {
                CommonsSessionStorageService.set('bobOrder', bobOrder);
            }

        }

        /**
            * Redirection to Home
            * @param {Event} backToMain Event that launch the function , this event is executed in ib-menus
            * @param {Boolean} goToHome  Indicate if the redirection is for Home
            * @param {Boolean} closeSession indicate if neccesary delete the session
            * @returns {void}
        */
        function backToMain (event, goToHome, closeSession) {
            ModalService.isWaiting();
            CloseSessionService.closeSession();
            if (goToHome) {
                //Clear own app session storage entries
                CommonsSessionStorageService.clearAll();
                $window.location.href = $window.location.origin;
            }
        }

        function setAircraftDatalayer () {
            const bookingInfo = CommonsSessionStorageService.get('bookingInfo');
            let aircraft;
            angular.forEach(bookingInfo.outwardSegments, (segment) => {
                aircraft = segment.aircraft;
            });
            return aircraft;
        }

        function getAppMarket () {
            return CommonsUtilService.getAppMarket();
        }

        function getPrefixFromMarket () {
            return CommonsUtilService.getPrefixFromMarket();
        }

        function updateLanguageAdditionalInfo (additionalInfo) {
            if(Array.isArray(additionalInfo)) {
                const confirmationDigitalInfo = localStorageService.get('confirmationDigitalInfo');
                additionalInfo.forEach(elem => {
                    if(elem.disruptionContact?.language) {
                        elem.disruptionContact.language = confirmationDigitalInfo.Language;
                    }
                });
            }

            return additionalInfo;
        }

        function getAppLang () {
            return $rootScope.appLang ? $rootScope.appLang : 'es';
        }

        function setTitlePage (title, time) {
            time = (time !== undefined || time!== null) ? time : 0;
            $timeout(() => {
                $window.document.title = $filter('translate')(title);
            }, time);
        }

        /**
         * Show alerts to the priority order of prohibited items
         * @param {Array} items
         * @returns
         */
        function showPriorityAlertInhibit (items) {
            const findInhibit = (code) => items.find((el) => el.code === code);
            const prioritiesReason = CheckinAppConstants.INHIBIT_BOARDING_CARD_PRIORITIES;
            let mostRestrictiveCode = null;
            let highestRestriction = -1;

            items.forEach((el) => {
                const code = el.code;
                const status = el.status;
                if (prioritiesReason[code] > highestRestriction && status) {
                    mostRestrictiveCode = code;
                    highestRestriction = prioritiesReason[code];
                }
            });
            const propertyName = Object.keys(prioritiesReason).find((key) => prioritiesReason[key] === highestRestriction);
            const priorityItem = findInhibit(propertyName);

            if (priorityItem) {
                priorityItem.status = true;
                priorityItem.showBox = priorityItem.code === CheckinAppConstants.ITEMS_TYPES.UMNR;
            }

            return priorityItem;
        }

        /**
         * Check to the order of priority of prohibited items
         * @param {Array} reasons
         * @returns inhibitReason
         */
        function checkInhibitReason (reasons) {
            const inhibitReason = {
                SEE_AGENT: false,
                AIRCHECK: false,
                BOKO: false,
                INHIBIT: false,
                RESI: false,
                UMNR: false,
                AVIH: false,
                PETC: false,
                COUR: false
            };

            reasons.forEach(reason => {
                switch (reason) {
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.SEE_AGENT_REASON:
                        inhibitReason.SEE_AGENT = true;
                        break;
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.INHIBIT_REASON:
                        inhibitReason.INHIBIT = true;
                        break;
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.AIRCHECK_REASON:
                        inhibitReason.AIRCHECK = true;
                        break;
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.RESI_REASON:
                        inhibitReason.RESI = true;
                        break;
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.UMNR_REASON:
                        inhibitReason.UMNR = true;
                        break;
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.AVIH_REASON:
                        inhibitReason.AVIH = true;
                        break;
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.PETC_REASON:
                        inhibitReason.PETC = true;
                        break;
                    case CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.COUR_REASON:
                        inhibitReason.COUR = true;
                        break;

                    default:
                        break;
                }
            });

            return inhibitReason;
        }

        /**
         * Check priority code reason to inhibit boarding card
         * @param {array} reason
         * @returns
         */
        function priorityInhibit (reason) {
            const codeRestrictions = CheckinAppConstants.INHIBIT_BOARDING_CARD_PRIORITIES;
            let mostRestrictiveCode = null;
            let highestRestriction = -1;

            reason.forEach((code) => {
                const item = code.replace('_REASON', '');
                if (codeRestrictions[item] > highestRestriction) {
                    mostRestrictiveCode = item;
                    highestRestriction = codeRestrictions[item];
                }
            });

            const propertyName = Object.keys(codeRestrictions).find((key) => codeRestrictions[key] === highestRestriction);
            return propertyName;
        }

        /**
         * Filter data market get from URL
         */
        function filterMarket (market) {
            const expressionLetters = /^[A-Za-z]+$/;
            const charsMarket = market.substring(0, 2);

            return expressionLetters.test(charsMarket) ? charsMarket : market;

        }

        function concatUnique(array1, array2) {
            const newArray = [];
            const set = new Set();

            for (const item of array1) {
                if (!set.has(item)) {
                    set.add(item);
                    newArray.push(item);
                }
            }

            for (const item of array2) {
                if (!set.has(item)) {
                    newArray.push(item);
                }
            }

            return newArray;
        }

        function updateApiEsta({ showTextEsta, text }) {
            if (showTextEsta) {
                estaConstraint.showTextEsta = showTextEsta;
            }

            if (text) {
                estaConstraint.text = text && text;
            }
        }

        function checkApisEsta () {
            return estaConstraint
        }

        function cleanDataSoftUser (value) {
            if (!value) return ''

            const isSoftUser = CommonsUserUtilsService.isSoftUser() || false;

            if (isSoftUser && value.includes('*')) return '';

            return value;
        }
    }

})();
